import React from 'react';
import { Radio } from '@mui/material';
import {
  FieldInputWrapper,
  TimelineWrapper,
  TimelineLine,
  TimelineArrow,
  OptionCardStyled,
  OptionHeader,
  OptionList,
  OptionListItem,
  OptionBox,
  RadioWrapper,
  StyledFormControlLabel,
} from './InnovationTool.css';
import { innovationCultureOptionCards } from './utils';

interface Props {
  fieldId: string;
  values: Record<string, any>;
  handleChange: {
    (e: React.ChangeEvent<any>): void;
    <T = string | React.ChangeEvent<any>>(
      field: T
    ): T extends React.ChangeEvent<any>
      ? void
      : (e: string | React.ChangeEvent<any>) => void;
  };
}

export const CustomRadioInput: React.FC<Props> = ({
  fieldId,
  values,
  handleChange,
}) => (
  <FieldInputWrapper>
    <TimelineWrapper>
      <TimelineLine />
      <TimelineArrow />
      {innovationCultureOptionCards.map((option, idx) => (
        <OptionBox key={option.header}>
          <OptionCardStyled
            style={{
              border:
                String(values[fieldId]) === String(option.value)
                  ? '3px solid #C4D600'
                  : '1px solid #e0e0e0',
            }}
            onClick={() => {
              handleChange({
                target: {
                  name: fieldId,
                  value: option.value,
                },
              });
            }}
          >
            <OptionHeader>{option.header}</OptionHeader>
            <OptionList>
              {option.items.map((item, itemIndex) => (
                <OptionListItem key={itemIndex}>{item}</OptionListItem>
              ))}
            </OptionList>
          </OptionCardStyled>
          <RadioWrapper>
            <StyledFormControlLabel
              value={idx}
              control={
                <Radio
                  checked={String(values[fieldId]) === String(option.value)}
                  onChange={handleChange}
                  sx={{
                    '&.Mui-checked': {
                      color: '#C4D600',
                    },
                    color: '#C4D600',
                    '& .MuiSvgIcon-root': {
                      borderRadius: '50%',
                      width: '24px',
                      height: '24px',
                    },
                  }}
                />
              }
              label=''
            />
          </RadioWrapper>
        </OptionBox>
      ))}
    </TimelineWrapper>
  </FieldInputWrapper>
);
